import {
    FETCH_AGGREGATE_FILTERS,
    FETCH_AGGREGATE_FILTERS_SUCCESS,
    FETCH_AGGREGATE_FILTERS_FAIL,
    CLEAR_AGGREGATE_FILTERS,
} from '../actions/aggregateFilters';

/**
 * Generic aggregate filters reducer.
 * Stores dynamic filter options keyed by field name.
 *
 * State shape:
 * {
 *   options: { [fieldName]: string[] },
 *   loading: boolean,
 *   error: null | object,
 *   activeFilters: null | object, // flat filters from the last aggregate fetch
 * }
 */
export const initialState = {
    options: {},
    loading: false,
    error: null,
    activeFilters: null,
};

const aggregateFilters = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_AGGREGATE_FILTERS:
            return {
                ...state,
                loading: true,
                error: null,
                activeFilters: action.payload?.flatFilters || null,
            };
        case FETCH_AGGREGATE_FILTERS_SUCCESS:
            return {
                ...state,
                options: {
                    ...state.options,
                    ...action.payload,
                },
                loading: false,
                error: null,
            };
        case FETCH_AGGREGATE_FILTERS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case CLEAR_AGGREGATE_FILTERS:
            return initialState;
        default:
            return state;
    }
};

export default aggregateFilters;
